// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 9792 ? "reactTeaserList01" : chunkId) + "." + {"9024":"17bdd851","9792":"3068e72f"}[chunkId] + ".chunk.css";
};